const Toggle = ({ checked, onChecked }) => {
  return (
    <>
      <label className='flex cursor-pointer select-none items-center'>
        <div className='relative'>
          <input
            type='checkbox'
            checked={checked}
            onChange={onChecked}
            className='sr-only'
          />

          <div className={`box block h-[28px] w-14 rounded-full ${checked ? 'bg-green-600' : 'bg-red-600'}`}></div>
          <div className={`absolute left-1 top-[3px] flex h-[22px] w-6 items-center justify-center rounded-full bg-white transition ${checked ? 'translate-x-full' : ''}`}>
          </div>
        </div>
      </label>
    </>
  )
}

export default Toggle;
